let collectionTitle, sortingOption, sortingOrder;

/* Instructions */

// collectionTitle: place "collection-handle" here, can be found in the URL on the collection page on the site; 

// sortingOption: available sorting options are - "title", "created", "price", "discount", "relevance", "sales_amount";
// sortingOrder: available sorting orders are - "asc" (stands for ascending), "desc" (stands for descending);

/*********************/

/* Edit settings below */

collectionTitle = "new-in";
sortingOption = "created";
sortingOrder = "desc";

/*********************/

document.addEventListener('Searchanise.Loaded', function() {
    (function($) {
        
        let snizeFakeResults = [];
        let snizeSuggestionsCount = Searchanise.GetWidgets().options.AutocompleteSuggestionCount;            
  
        let manualCollections = Object.entries(Searchanise.GetWidgets().options.ResultsManualSortingCategories);
        let isCollectionManual = false;
        let manualCollectionID;

        for (let i = 0; i < manualCollections.length; i++) {
            if (manualCollections[i][0] == collectionTitle) {
                isCollectionManual = true;
                manualCollectionID = manualCollections[i][1];
            }
        }

        let availableSortingOptions = ['title', 'created', 'price', 'discount', 'relevance', 'sales_amount'];
        let availableSortingOrders = ['asc', 'desc'];

        if (!isCollectionManual) {
            if (!availableSortingOptions.includes(sortingOption) || !availableSortingOrders.includes(sortingOrder)) {
                return; 
            }
        }

        async function insertFakeResults(container, input) {
            if (!snizeFakeResults.length) {
                $('.snize-ac-results-content:not(.hidden)').addClass('hidden');
                if (isCollectionManual) {
                    await $.get('https://searchserverapi1.com/getresults?api_key=0j0o2j1Y5d&items=true&facets=false&sortBy=collection_' + manualCollectionID + '_position', function(data) {
                        snizeFakeResults = JSON.parse(data).items;
                    });
                } else {
                    await $.get('https://searchserverapi1.com/getresults?api_key=0j0o2j1Y5d&items=true&facets=false&collection=' + collectionTitle + '&sortBy=' + sortingOption + '&sortOrder=' + sortingOrder, function(data) {
                        snizeFakeResults = JSON.parse(data).items;
                    });
                }
            }
            
            $('.snize-ac-results-content.hidden').removeClass('hidden');
            
            isInputValue = window.innerWidth < 821 && $('#snize-mobile-search-input').length ? Boolean($('#snize-mobile-search-input').val()) : Boolean($(input).val());

            if (!isInputValue) {
                $('.snize-no-products-found').remove();
                if (!$('#snize-ac-items-container-4 .snize-label', container).length) {
                    $('#snize-ac-items-container-4', container).prepend(`<li class="snize-label">TRENDING PRODUCTS</li>`);
                }
                snizeFakeResults.forEach((item) => {
                    if ($('.snize-product', container).length == Searchanise.GetWidgets().options.AutocompleteItemCount) {
                        return;
                    }
                    if (window.innerWidth > 1024) {
                        $('#snize-ac-items-container-4', container).append(
                        `<li class="snize-product" id="snize-ac-product-${item.product_id}" style="cursor: pointer;"><a href=${item.link} class="snize-item" draggable="false"><div class="snize-thumbnail"><img src=${item.image_link} class="snize-item-image " alt="${item.title}"></div><span class="snize-title">${item.title}</span><span class="snize-description" style="max-height: 2.8em; -webkit-line-clamp: 2;">${item.description}</span><div class="snize-price-list"><span class="snize-price snize-price-with-discount money ">${Searchanise.GetWidgets().formatPrice(item.price)}</span></div></a></li>`);
                    } else {
                        $('#snize-ac-items-container-4', container).append(
                        `<li class="snize-product" id="snize-ac-product-${item.product_id}" style="cursor: pointer;"><a href="${item.link}" class="snize-item"><div class="snize-thumbnail"><img src="${item.image_link}" class="snize-item-image " alt="${item.title}"></div><div class="snize-product-info"><span class="snize-title">${item.title}</span><span class="snize-description" style="max-height: 2.8em; -webkit-line-clamp: 2;">${item.description}</span><div class="snize-ac-prices-container"><div class="snize-price-list"><span class="snize-price snize-price-with-discount money theme-money ">${Searchanise.GetWidgets().formatPrice(item.price)}</span></div></div></div></a></li>`);
                    }
                });
                $('.snize-ac-results-columns', container).removeClass('snize-hidden');
                $('#snize-ac-items-container-4', container).removeClass('snize-hidden');
                $('#snize-ac-items-container-2', container).removeClass('snize-hidden');  
            } 
        }
        
        $(document).on("Searchanise.AutocompleteUpdated", function(event, input, container) {
            insertFakeResults(container, input);
        });
        {
            $('body').append(
                `<style>
                    .snize-ac-results-content.hidden {
                        display: none !important;
                    }

                    .snize-ac-results .snize-product-info {
                        flex-direction: column;
                    }
                </style>`
            );
        }
    })(window.Searchanise.$);
});